
.textSecondary {
  font-size: 14px;
  line-height: 20px;
  @include themify($themes) {
    color: themed("neutral-to-primary");
  }
  margin-bottom: 12px;
}

.permissionTitle {
  margin-top: 20px;
}

.permissionRow {
  display: flex;
  margin-top: 10px;
  cursor: pointer;

  .checkbox {
    flex: 0 0 20px;
    margin-right: 10px;
  }
  
  .caption {
    flex: 1;
    flex-shrink: 0;
  }
}


.domainPermissions {
  @include themify($themes) {
    border-top: 1px solid themed("neutral-secondary");
  }
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  padding: 10px 0;

  .permissions {
    @include themify($themes) {
      border-top: 1px solid themed("neutral-secondary");
    }
    margin-top: 10px;

    .permission {
      width: 160px;
      display: inline-flex;
      margin-top: 10px;
      cursor: pointer;
      .checkbox {
        flex: 0;
        width: auto;
        margin-right: 10px;
      }
    }
  }
}
